import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toTree' })
export class ToTreePipe implements PipeTransform {

  transform (list: any[], args?: any): any {
    const [ parentIdKey = 'parentId', idKey = 'id' ] = args[0]
    const tree = list.filter(item => !item[parentIdKey])
    recurseAddChildren(list, tree, parentIdKey, idKey)
    return tree
  }
}

function recurseAddChildren (list: any[], nodes: any[], parentIdKey, idKey) {
  nodes.forEach(node => {
    // TODO: 不通用
    node.value = node.key = node[idKey]
    node.label = node.title = node.name
    node.children = list.filter(item => item[parentIdKey] === node[idKey])
    recurseAddChildren(list, node.children, parentIdKey, idKey)
  })
}
